import Base from '@/plugins/Base';
import router from '@/plugins/Router'

const module = {
    namespaced: true,
    state: () => ({
        data: {},
        nationalID: null,
        pin: null,
        tab: -1,
        time: null,
        mernis: null
    }),
    getters: {
        getData(state) {
            return state.data
        },
        getStatus(state){
            return state.data && state.data.status ? state.data.status:null;
        },
        getNationalID(state) {
            return state.nationalID
        },
        getPin(state) {
            return state.pin
        },
        getTab(state) {
            return state.tab
        },
        getTime(state) {
            return state.time
        },
        getMernis(state) {
            return state.mernis
        }
    },

    mutations: {
        setData(state, data) {
            state.data = data
            Base.LocalStorage.set('conservatory_app_data', state.data)
        },
        setStatus(state, status) {
            state.data.status = status;
            Base.LocalStorage.set('undergraduate_transfer_data', state.data)
        },
        setNationalID(state, nationalID) {
            state.nationalID = nationalID
            Base.LocalStorage.set('conservatory_app_id', state.nationalID)
        },
        setPin(state, pin) {
            state.pin = pin
            Base.LocalStorage.set('conservatory_app_pin', state.pin)
        },
        setTab(state, tab) {
            state.tab = tab
            Base.LocalStorage.set('conservatory_app_tab', state.tab)
        },
        setTime(state, time) {
            state.time = time
            Base.LocalStorage.set('conservatory_app_time', state.time)
        },
        setMernis(state, mernis) {
            state.mernis = mernis
            Base.LocalStorage.set('conservatory_app_mernis', state.mernis)
        },
        clearData(state) {
            state.data = {}
            state.nationalID = null
            state.pin = null
        },
        clearMernis(state) {
            state.mernis = null
            Base.LocalStorage.set('conservatory_app_mernis', null)
        }
    },

    actions: {
        initData({commit}) {
            let data = Base.LocalStorage.get('conservatory_app_data')
            let nationalID = Base.LocalStorage.get('conservatory_app_id')
            let pin = Base.LocalStorage.get('conservatory_app_pin')
            let tab = Base.LocalStorage.get('conservatory_app_tab')
            let time = Base.LocalStorage.get('conservatory_app_time')
            let mernis = Base.LocalStorage.get('conservatory_app_mernis')
            if (data && nationalID && pin) {
                commit('setData', data)
                commit('setNationalID', nationalID)
                commit('setPin', pin)
                commit('setTab', tab)
                commit('setTime', time)
                commit('setMernis', mernis)
            }
        },

        isLogin({state}) {

            let data = state.data;
            let nationalID = state.nationalID;
            let pin = state.pin;
            if (!data || !nationalID || !pin) {
                router.push('/conservatory/application/login')
            }
        },

        isLoginGoIndex({state}) {
            let data = state.data;
            let nationalID = state.nationalID;
            let pin = state.pin;
            if (data && nationalID && pin) {
                router.push('/conservatory/application/form')
            }
        },

        logout({commit}) {
            commit('clearData')
            Base.LocalStorage.remove('conservatory_app_data')
            Base.LocalStorage.remove('conservatory_app_id')
            Base.LocalStorage.remove('conservatory_app_pin')
            Base.LocalStorage.remove('conservatory_app_tab')
            Base.LocalStorage.remove('conservatory_app_time')
            Base.LocalStorage.remove('conservatory_app_mernis')

            router.push('/conservatory/application/login')
        }
    }
}

export default module;
